<template>
    <ValidationObserver ref="form">
        <div v-if="Object.keys(formData.fields).length > 0" class="md-layout">
            <div
                    class="md-layout-item md-small-size-100 md-medium-size-70"
                    style="padding-left: 0 !important;"
            >
                <div class="md-layout">
                    <md-card>
                        <md-card-header
                                class="md-card-header-icon md-card-header-green"
                        >
                            <div class="card-icon">
                                <md-icon>person</md-icon>
                            </div>
                            <h4 class="title">{{$t("patient_info")}}</h4>
                        </md-card-header>
                        <md-card-content class="md-layout">
                            <div
                                    class="md-layout-item md-small-size-50"
                                    style="padding-left: 0 !important;"
                            >
                                <TextInput
                                        :form-row="formData.fields['nombre']"
                                        :objeto.sync="pacienteReactivo"
                                >
                                </TextInput>
                            </div>
                            <div
                                    class="md-layout-item md-small-size-50"
                                    style="padding-left: 0 !important;"
                            >
                                <TextInput
                                        :form-row="formData.fields['apellidos']"
                                        :objeto.sync="pacienteReactivo"
                                >
                                </TextInput>
                            </div>
                            <div
                                    class="md-layout-item md-small-size-50"
                                    style="padding-left: 0 !important;"
                            >
                                <TextInput
                                        :form-row="
                                        formData.fields['numeroHabitacion']
                                    "
                                        :objeto.sync="pacienteReactivo"
                                >
                                </TextInput>
                            </div>
                            <div
                                    class="md-layout-item md-small-size-50"
                                    style="padding-left: 0 !important;"
                            >
                                <SelectList
                                        :form-row="formData.fields['sexo']"
                                        :objeto.sync="pacienteReactivo"
                                >
                                </SelectList>
                            </div>
                            <div
                                    class="md-layout-item md-small-size-50"
                                    style="padding-left: 0 !important;"
                            >
                                <DateInput
                                        :form-row="
                                        formData.fields['fechaNacimiento']
                                    "
                                        :objeto.sync="pacienteReactivo"
                                >
                                </DateInput>
                            </div>
                            <div
                                    class="md-layout-item md-small-size-50"
                                    style="padding-left: 0 !important;"
                            >
                                <SelectList
                                        :form-row="formData.fields['sensor']"
                                        :objeto.sync="pacienteReactivo"
                                >
                                </SelectList>
                            </div>
                            <div
                                    class="md-layout-item md-small-size-100"
                                    style="padding-left: 0 !important;"
                            >
                                <SelectList
                                        :form-row="formData.fields['seccion']"
                                        :objeto.sync="pacienteReactivo"
                                >
                                </SelectList>
                            </div>
                        </md-card-content>
                    </md-card>
                    <md-card>
                        <md-card-header
                                class="md-card-header-icon md-card-header-green"
                        >
                            <div class="card-icon">
                                <md-icon>invert_colors_off</md-icon>
                            </div>
                            <h4 class="title">{{$t("paciente.alarma_orina")}}</h4>
                        </md-card-header>
                        <md-card-content class="md-layout">
                            <div
                                    class="md-layout"
                                    style="padding-left: 0 !important;"
                            >
                                <div
                                        class="md-layout-item md-small-size-50"
                                        style="padding-left: 0 !important;"
                                >
                                    <CheckBox
                                            :form-row="
                                            formData.fields['noUrineAlarm']
                                        "
                                            :objeto.sync="pacienteReactivo"
                                    >
                                    </CheckBox>
                                </div>
                                <div
                                        v-show="pacienteReactivo['noUrineAlarm']"
                                        class="md-layout-item md-small-size-50"
                                        style="padding-left: 0 !important;"
                                >
                                    <SelectList
                                            :form-row="
                                            formData.fields['noUrineHours']
                                        "
                                            :objeto.sync="pacienteReactivo"
                                    >
                                    </SelectList>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
            </div>
            <div
                    class="md-layout-item md-small-size-100 md-medium-size-30"
                    style="padding-left: 0 !important;"
            >
                <div class="md-layout">
                    <md-card>
                        <md-card-header
                                class="md-card-header-icon md-card-header-green"
                        >
                            <div class="card-icon">
                                <md-icon>pin_drop</md-icon>
                            </div>
                            <h4 class="title">{{$t("paciente.posicion")}}</h4>
                        </md-card-header>
                        <md-card-content class="md-layout">
                            <div class="md-layout-item md-small-size-100" style="padding-left: 0 !important;">
                                <CheckBox
                                        :form-row="formData.fields['allowPatientLocation']"
                                        :objeto.sync="pacienteReactivo">
                                </CheckBox>
                            </div>
                        </md-card-content>
                    </md-card>
                    <md-card>
                        <md-card-header
                                class="md-card-header-icon md-card-header-green"
                        >
                            <div class="card-icon">
                                <md-icon>accessibility_new</md-icon>
                            </div>
                            <h4 class="title">{{$t("paciente.actividad")}}</h4>
                        </md-card-header>
                        <md-card-content>

                            <div class="" style="padding-left: 0 !important;">
                                <CheckBox
                                        :form-row="formData.fields['allowActivityTracking']"
                                        :objeto.sync="pacienteReactivo">
                                </CheckBox>
                            </div>
                            <div class="md-layout" v-show="pacienteReactivo['allowActivityTracking']">
                                <div class="md-layout-item md-size-50" style="padding-left: 0 !important;">
                                    <CheckBox
                                            :form-row="formData.fields['autoCorrectedAngle']"
                                            :objeto.sync="pacienteReactivo">
                                    </CheckBox>
                                </div>
                                <div class="md-layout-item md-size-50" style="padding-left: 0 !important;">
                                    <TextInput
                                            :form-row="formData.fields['autoCorrectedAngleValue']"
                                            :objeto.sync="pacienteReactivo">
                                    </TextInput>
                                </div>
                            </div>
                            <div class="md-layout" v-show="pacienteReactivo['allowActivityTracking']">
                                <div class="md-layout-item md-size-50" style="padding-left: 0 !important;">
                                    <CheckBox
                                            :form-row="formData.fields['rotationAlarm']"
                                            :objeto.sync="pacienteReactivo">
                                    </CheckBox>
                                </div>
                                <div v-show="pacienteReactivo['rotationAlarm']"
                                     class="md-layout-item md-size-50"
                                     style="padding-left: 0 !important;">
                                    <SelectList
                                            :form-row="formData.fields['stoppedTime']"
                                            :objeto.sync="pacienteReactivo">
                                    </SelectList>
                                </div>
                            </div>
                        </md-card-content>
                    </md-card>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    let BACKEND_API = process.env.VUE_APP_BACKEND_API;
    import {authHeader} from "../../helpers/auth-header";
    import {handleResponse} from "../../helpers/handle-response";
    import TextInput from "../../formElements/TextInput";
    import SelectList from "../../formElements/SelectList";
    import DateInput from "../../formElements/DateInput";
    import ObjectInput from "../../formElements/ObjectInput";
    import CheckBox from "../../formElements/CheckBox";

    export default {
        name: "patient_form",
        components: {TextInput, SelectList, DateInput, CheckBox},
        props: {
            paciente: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        mounted() {
            this.formConfig();
        },
        data() {
            return {
                isLoading: false,
                pacienteReactivo: JSON.parse(JSON.stringify(this.paciente)),
                formData: {
                    fields: {}
                }
            };
        },
        destroyed() {
        },
        methods: {
            validate() {
                return this.$refs.form.validate().then(res => {
                    this.$emit("on-validated", this.pacienteReactivo);
                    return res;
                });
            },
            formConfig() {
                let self = this;
                fetch(
                    `${BACKEND_API}/api/pacientes/prepare?id=` +
                    this.pacienteReactivo.id,
                    {
                        method: "GET",
                        headers: authHeader()
                    }
                )
                    .then(handleResponse)
                    .then(function (data) {
                        self.formData = data[1];
                    });
            }
        }
    };
</script>
